var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle109(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "249.14991038195296 193.16979707464856 22.58284200095335 22.561383734330235",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M260.44,211.73c-4.13.07-7.27-2.98-7.29-7.09-.02-4.2,3.31-7.5,7.52-7.47,3.93.03,6.96,2.98,7.06,6.88.11,4.24-3.09,7.61-7.29,7.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle109);
export default __webpack_public_path__ + "static/media/twinkle-1-09.c1c063d6f01c55b129ead972d15c2522.svg";
export { ForwardRef as ReactComponent };